<template>
  <div class='chat-content'>
    <div class="chat_room_title">
      <div class="title_icon">
        <img src="/static/images/chatRoom.png"
             style="width:24px;height:24px">
        <span class="chat_room_title_span">{{ $t('video.chatRoom') }}</span>
      </div>
      <i class="el-icon-close"
         v-if="!isAdmin"
         @click="close"></i>
      <div v-else
           class="admin">{{$t('text.admin')}}</div>
    </div>
    <div class="chat_content"
         v-for="(item,idx) in chatContentList"
         :key="idx"
         :style="{paddingBottom:idx==chatContentList.length-1?'70px':''}">
      <span class="chat_content_user_name"
            :style="{color:!isAdmin && item.user_id === userInfo.id?'#FE4987':isVideoDetail?'#fff':''}">{{!isAdmin && item.user_id === userInfo.id?$t('video.me'):item.user_name}}:</span>
      <span class="chat_content_content"
            :style="{color:isVideoDetail?'#fff':''}">{{item.content}}</span>
      <span class="chat_content_time">{{item.time}}</span>
      <span @click="deleteMessage(item.id)"
            class="delete"
            v-if="isAdmin">{{$t('text.delete')}}</span>
    </div>
    <div class="publish"
         v-show="!isAdmin"
         :style="{width:isVideoDetail ? videoWidth+'px' : '100%',bottom: isVideoDetail ? '10px' : '0'}">
      <el-input v-model="publishContent"
                :autofocus="false"
                @keyup.enter.native="postMessage"></el-input>
      <el-button class="publish_btn"
                 round
                 @click="postMessage"
                 :loading="isPublish"
                 type='text'><span>{{ $t('video.publish') }}</span></el-button>
    </div>
  </div>
</template>
<script>
import { postMsg, getMsg, deleteMsg } from '@/utils/api'
export default{
    props: {
        userInfo: {},
        isVideoDetail: {
            default: false,
            type: Boolean
        },
        videoWidth: {
            default: 0,
            type: Number
        }
    },
    data() {
        return {
            publishContent: '',
            chatContentList: [],
            isPublish: false,
            isAdmin: false
        }
    },
    created() {
        this.isAdmin = this.$route.query.adminToken && this.$route.query.adminToken === this.$store.state.adminToken
        if (this.isAdmin) this.optChatRoomContent()
    },
    methods: {
        deleteMessage(id) {
            this.$confirm(this.$t('text.deleteConfirmText'), this.$t('text.tips'), {
                confirmButtonText: this.$t('text.confirm'),
                cancelButtonText: this.$t('text.cancel'),
                type: 'warning'
            }).then(() => {
                deleteMsg(id).then(res => {
                    this.chatContentList.map((item, idx) => {
                        if (item.id === id) {
                            this.chatContentList.splice(idx, 1)
                            this.$message({
                                type: 'success',
                                message: this.$t('text.deleteSuccess')
                            })
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'error',
                        message: this.$t('text.deleteFail')
                    })
                })
            }).catch(() => {
            })
        },
        close() {
            this.isVideoDetail ? this.$parent.changeChatRoomStatus() : this.$parent.$parent.changeChatRoomStatus()
        },
        optChatRoomContent() {
            this.publishContent = ''
            if (this.isAdmin ? this.isAdmin : this.isVideoDetail ? this.$parent.isOpenChatRoom : this.$parent.$parent.isOpenChatRoom) {
                // init chatRoom
                this.chatContentList = []
                getMsg(50).then(res => {
                    this.chatContentList = res.data.data
                    this.chatContentList.map(item => {
                        item.time = this.getChatTime(item.time)
                    })
                    let timer = 5000
                    let getContentInterval = setInterval(getMessage, timer)
                    let that = this
                    this.scrollToBottom()
                    function getMessage() {
                        clearInterval(getContentInterval)
                        getMsg(10, that.chatContentList[that.chatContentList.length - 1].id).then(val => {
                            if (val.data.data.length === 0) {
                                timer += 10000
                            } else {
                                val.data.data.map(item => {
                                    item.time = that.getChatTime(item.time)
                                })
                                that.chatContentList.push(...val.data.data)
                                let newObj = {}
                                let newArr = []
                                for (let i = 0; i < that.chatContentList.length; i++) {
                                    let temp = that.chatContentList[i]
                                    if (!newObj[temp['id']]) {
                                        newObj[temp['id']] = newArr.push(temp)
                                    }
                                }
                                that.chatContentList = newArr
                                let curScrollTop
                                if (that.isAdmin) {
                                    curScrollTop = that.$el.querySelector('.chat_content')
                                } else {
                                    curScrollTop = that.isVideoDetail ? that.$parent.$el.querySelector('.video-bottom-chat-room') : that.$parent.$el.querySelector('.el-drawer__body')
                                }
                                if ((curScrollTop.scrollTop + curScrollTop.clientHeight) === curScrollTop.scrollHeight) {
                                    that.scrollToBottom()
                                }
                            }
                            if (that.isAdmin ? that.isAdmin : that.isVideoDetail ? that.$parent.isOpenChatRoom : that.$parent.$parent.isOpenChatRoom) getContentInterval = setInterval(getMessage, timer)
                        })
                    }
                })
            }
        },
        getChatTime(nS) {
            return new Date(parseInt(nS)).toLocaleString().replace(/:\d{1,2}$/, ' ')
        },
        postMessage() {
            if (this.publishContent !== '') {
                let token = localStorage.getItem('user_token')
                this.isPublish = true
                postMsg(this.publishContent, token).then(res => {
                    this.isPublish = false
                    let currentContent = {
                        'content': this.publishContent,
                        'id': res.data.data.id,
                        'time': res.data.data.time ? this.getChatTime(res.data.data.time) : this.getChatTime(new Date().getTime()),
                        'type': 'room',
                        'user_id': res.data.data.user_id ? res.data.data.user_id : this.userInfo.id,
                        'user_name': res.data.data.user_name ? res.data.data.user_name : this.userInfo.name
                    }
                    this.chatContentList.push(currentContent)
                    this.publishContent = ''
                    this.scrollToBottom()
                })
            }
        },
        scrollToBottom() {
            this.$nextTick(() => {
                let scrollTop
                if (this.isAdmin) {
                    scrollTop = this.$el.querySelector('.chat_content')
                } else {
                    scrollTop = this.isVideoDetail ? this.$parent.$el.querySelector('.video-bottom-chat-room') : this.$parent.$el.querySelector('.el-drawer__body')
                }
                scrollTop.scrollTop = scrollTop.scrollHeight
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.chat_room_title{
    width: 100%;
    height: 38px;
    background-color: #fff;
    box-shadow: 0px 2px 4px 0px rgba(222, 222, 222, 0.5);
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    position: sticky;
    top:0;
}
.title_icon{
    margin-left: 3%;
}
.chat_room_title_span{
    margin-left:10px
}
.delete{
    color: #000000;
    margin-left:10px;
    cursor: pointer;
    font-size: 14px
}
>>>.el-icon-close{
    margin-right: 2%;
    cursor: pointer;
}
.admin{
    margin-right: 2%;
}
.chat_content{
    text-align: left;
    width: 95%;
    margin-left: 2.5%;
    margin-top: 10px;
    word-break: break-all;
}
.chat_content_user_name{
    font-size: 17px;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
}
.chat_content_time{
    color: #b1b1b1;
    margin-left: 10px;
    font-size: 15px
}
.publish{
    position: fixed;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
}
>>>.el-input{
    width: 60%;
}
>>>.el-input__inner {
    border-radius: 20px;
    background-color: #EFF8FD;
    border: 1px solid #D1D1D1 !important;
    color: #000000
}
.publish_btn{
    width: 100px;
    background: #FE4987 !important;
    color:#fff !important;
    margin-left: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/ChatContent.vue